// extracted by css-extract-rspack-plugin
export default {"HeroSection":"HeroSection-module__HeroSection__gXfQJ"};